module.exports = ".btn-asambleas-red {\n  border-radius: 100px;\n  color: white; }\n\n.card-body {\n  padding: 0.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/user-form-modal/user-form-modal.component.scss
// module id = ./src/app/components/modals/user-form-modal/user-form-modal.component.scss
// module chunks = main